import { EAssetType } from 'constants/enums';
import { ROLLING_OFFER_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { InputSelectDropdownOption } from 'components/InputSelectDropdown/InputSelectDropdown';

import {
  PERCENTAGE_LEFT_ICON,
  PERCENTAGE_LEFT_ICON_STYLES
} from '../FormFields.consts';
import {
  GradientFieldConfig,
  NumberFieldConfig,
  TextFieldConfig,
  UploadFieldConfig
} from '../FormFields.types';

export { ROLLING_OFFER_DEFAULTS };

export const FREE_TILES_LAYOUT_OPTIONS: InputSelectDropdownOption[] = [
  { value: '1', label: '1 in a row' },
  { value: '2', label: '2 in a row' },
  { value: '3', label: '3 in a row' }
];

export const PLUS_IMAGE_UPLOAD: UploadFieldConfig = {
  title: 'Plus Image',
  fieldName: 'plusImage',
  forceType: EAssetType.GENERAL,
  tooltip:
    'Upload a 1:1 ratio image used as the visual plus separator between the paid tile and the free tiles.',
  isRequired: true
};

export const COLLECT_TEXT_FIELD: TextFieldConfig = {
  label: 'Free Offer Text',
  name: 'collectText',
  placeholder: 'FREE',
  defaultValue: ''
};

export const BG_BORDER_ROW_GRADIENT: GradientFieldConfig = {
  header: 'Background Color',
  name: 'backgroundColor',
  fallback: ROLLING_OFFER_DEFAULTS.backgroundColor,
  required: true,
  dataTestId: 'offer-design-buy-one-get-many-main-background-color-input'
};

export const BG_BORDER_ROW_WIDTH: NumberFieldConfig = {
  label: 'Background opacity',
  name: 'backgroundOpacity',
  min: 0,
  max: 100,
  isRequired: true,
  leftIcon: PERCENTAGE_LEFT_ICON,
  leftIconStyles: PERCENTAGE_LEFT_ICON_STYLES
};

export const BORDER_ROW_GRADIENT: GradientFieldConfig = {
  header: 'Border Color',
  name: 'borderColor',
  fallback: ROLLING_OFFER_DEFAULTS.borderColor,
  dataTestId: 'offer-design-buy-one-get-many-main-border-color-input'
};

export const BORDER_ROW_WIDTH: NumberFieldConfig = {
  label: 'Offer border width',
  name: 'borderWidth',
  min: 0,
  max: 8,
  isRequired: true
};

export const SUB_OFFER_BG_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Offers background color',
    name: 'offersBackgroundColor',
    fallback: ROLLING_OFFER_DEFAULTS.subOfferBackgroundColor,
    required: true,
    dataTestId:
      'offer-design-buy-one-get-many-sub-offers-background-color-input'
  }
];

export const MAIN_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Offer Header Image',
    fieldName: 'headerImage',
    forceType: EAssetType.OFFER_HEADER,
    tooltip: 'Upload an image for the offer header.'
  },
  {
    title: 'Background Image',
    fieldName: 'backgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a background image for the 1+Many offer.'
  }
];
